<template>
  <v-app style="background-color:black;">
    <v-app-bar
      v-if="$router.history.current['path'] === '/admin/admindancers'|| $router.history.current['path'] === '/admin/edittext'"
      app
      color="black"
      dark
    >
      <div
        class="d-flex align-center"
        style="cursor: pointer"
      >
        <h1 class="hover-underline-animation">
          GFB ADMINISTRACE
        </h1>
      </div>

      <v-spacer />
      <v-btn
        text
        to="edittext"
      >
        Upravit text
      </v-btn>
      <v-btn
        text
        to="admindancers"
      >
        Dancers
      </v-btn>
      <v-btn
        text
        @click="logout"
      >
        Log Out
      </v-btn>
    </v-app-bar>

    <v-app-bar
      v-else-if="$router.history.current['path'] === '/admin' || $router.history.current['path'] === '/admin/'"
      app
      color="black"
      dark
    >
      <div
        class="d-flex align-center"
        style="cursor: pointer"
      >
        <h1 class="hover-underline-animation">
          GFB ADMINISTRACE
        </h1>
      </div>
    </v-app-bar>

    <v-app-bar
      v-else-if="$router.history.current['path'] !== '/admin/admindancers'"
      app
      color="black"
      dark
    >
      <div
        class="d-flex align-center"
        style="cursor: pointer"
        @click="$router.push('/')"
      >
        <h1 class="hover-underline-animation">
          GFB
        </h1>
      </div>

      <v-spacer />

      <v-btn
        text
        to="about"
      >
        Info
      </v-btn>
      <v-btn
        text
        to="galery"
      >
        Galerie
      </v-btn>
      <v-btn
        text
        to="registration"
      >
        Registrace
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
  methods: {
    logout () {
      localStorage.clear()
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Six+Caps&display=swap');
body, html{
  height: 100vh;
}

h1 {
  display: inline-block;
  position: relative;
color: #f9d71c;
font-family: 'Six Caps', sans-serif;
font-size: 40px;
}

h1:after {
  content: '';
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 5px;
  bottom: 0;
  left: 0;
  background-color: #fd48fe;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

h1:hover:after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
</style>